import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import Input from "~/components/Form/LandingInput"
import Spacer from "~/components/Spacer"
import FormError from "~/components/Form/ErrorText"
import Tooltip from "~/components/Tooltip"
import InputTitle from "./InputTitle"
import withTranslations from "~/components/_hocs/withTranslations"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`

@inject(all => ({
  validateDisplayMessage:
    all.store.parkingFlow.searchCriteria.validateDisplayMessage,
  setTicketId: all.store.parkingFlow.searchCriteria.setTicketId,
  ticketId: all.store.parkingFlow.searchCriteria.ticketId
}))
@observer
class TicketNumberInput extends Component {
  handleChange = e => {
    this.props.setTicketId(e.target.value)
  }

  render() {
    const ticketErrorHandler = this.props.validateDisplayMessage("ticketId")
    return (
      <Wrap>
        <InputTitle>
          {this.props.translate('label')}
          <Tooltip
            size={21}
            message={this.props.translate('tooltip')}
            icon="question"
          />
        </InputTitle>
        <Spacer desktop={16} mobile={16} />
        <Input
          placeholder="Ex: 1234567890"
          value={this.props.ticketId}
          onChange={this.handleChange}
          onKeyDown={this.props.onEnterSubmit}
          error={ticketErrorHandler}
          maxLength={10}
        />
        <FormError error={ticketErrorHandler} />
      </Wrap>
    )
  }
}

export default withTranslations(TicketNumberInput, 'form.parking.ticketNumber')
